export const zhTWDictionary = {
    lineup: "陣容",
    catchphrase: "找到您喜愛的商品",
    guide: {
        title: "購買前須知",
        subtitle: "事先檢查",
        what_is_service: "Web ROLL是什麼？",
        delivery: "關於配送",
        qa: "常見問題",
        contact: "聯絡我們",
        guide_to_signup: "首次使用請看這裡",
        login: "登入",
        signup: "免費會員註冊",
        link_login: "點此登入",
        link_signup: "點此註冊新會員",
        login_sns: "使用SNS帳號輕鬆登入",
        signup_sns: "使用SNS帳號輕鬆註冊",
        email_login: "使用電子郵件地址登入",
        email_signup: "使用電子郵件地址註冊",
        google_login_support: "無法使用Google登入的客戶",
        login_form: {
            email: "電子郵件地址",
            password: "密碼",
            login_button: "使用E-mail登入",
            signup_button: "使用E-mail註冊",
            agree: "同意",
            forgot_password: "忘記密碼"
        },
        login_alert: {
            title: "註冊成為會員\n即可使用\nWeb ROLL",
            description: "您可以使用SNS帳號輕鬆註冊",
            login_button: "登入",
            signup_button: "免費會員註冊"
        }
    },
    gacha: {
        selling_status: {
            ended: "銷售結束了",
            selling: {
                day: "還有{{value}}天",
                hour: "還有{{value}}小時",
                minute: "還有{{value}}分鐘",
                absolute: "(預計於{{date}}結束銷售)"
            },
            comingsoon: {
                day: "距離銷售開始還有{{value}}天",
                hour: "距離銷售開始還有{{value}}小時",
                minute: "距離銷售開始還有{{value}}分鐘",
                absolute: "(預計於{{date}}開始)"
            },
            play_limit: {
                reached_play_limit: "您已達到今日購買上限",
                remaining_play_limit: "今日剩餘購買次數：{{value}}次"
            },
        },
        description: {
            more: "更多",
            close: "關閉"
        }
    },
    gift_code: {
        input: {
            title: "輸入禮物碼",
            cancel: "取消",
            scan_qr: "掃描QR碼",
            submit: "添加至帳戶",
            code_placeholder: "在此輸入禮物碼",
            require_code_error: "請輸入禮物碼",
            or: "或"
        }
    },
    global: {
        header: {
            history: "購買歷史",
            menu: "菜單",
            signup_or_login: "免費會員註冊·登入",
            menus: {
                mypage: "我的頁面",
                logout: "登出",
                login: "登入",
                signup: "免費會員註冊",
                acquired_items: "獲得的商品",
                input_code: "輸入代碼",
                gift_code: "禮物碼",
                play_ticket: "免費票券",
                prize_ticket: "票券/优惠券",
                user_id: "使用者ID : {{id}}"
            }
        },
        footer: {
            company: "公司概況",
            privacy: "隱私政策",
            terms: "使用條款",
            contact: "聯絡我們",
            specified_commercial_transactions: "特定商業交易法的標示"
        },
        login: {
            status: {
                google: "使用Google帳戶登入中",
                password: "使用電子郵件地址登入中",
                unknown: "無登入資訊"
            },
            success: "登入成功",
            error: {
                title: "登入失敗",
                description: "如果問題持續存在，請使用其他認證方法。"
            }
        },
        signup: {
            error: {
                title: "註冊失敗",
                description: "如果問題持續存在，請使用其他認證方法。"
            }
        },
        common: {
            tax: {
                included: "含稅",
                excluded: "不含稅"
            },
            piece: "次",
            sum: "總計",
            delivery_fee: "配送費",
            prize_unit: "個",
            remain_delivery_count: "再購買{{bundle_amount}}個即可免運費",
            jst_date_warning: "所示時間為日本標準時間(JST)",
            ok: "確定",
            cancel: "取消",
            register: "註冊",
            submit: "提交",
            company: "公司概況",
            privacy: "隱私政策",
            terms: "使用條款",
            contact: "聯絡我們",
            specified_commercial_transactions: "特定商業交易法的標示"
        },
        adult_contents: {
            question_of_adulthood: {
                title: "您是否已滿18歲？",
                description: "除了一般作品外，還包含暴力和性描述等不適合18歲以下人士觀看的信息。"
            },
            contents_switch: {
                general: "一般向",
                adult: "成人內容(R-18)"
            }
        }
    },
    components: {
        view_registered_address: "檢視已註冊的配送地址",
        shipping_forms: {
            country: "配送國家",
            name: "姓名",
            phone: "電話號碼",
            zip_code: "郵遞區號",
            email: "電子郵件地址",
            full_address: "地址",
            prefecture: "都道府縣",
            city: "市區鎮村",
            address1: "丁目、番地",
            address2: "公寓·大廈·房間號碼",
            auto_fill: "地址檢索",
            errors: {
                is_required: "必填項目",
                address_auto_fill_not_in_service: "地址檢索僅適用於日本郵遞區號",
                is_invalid_phone_number: "請輸入有效的電話號碼",
                is_invalid_email: "請輸入有效的電子郵件地址",
                is_invalid_zip_code: "請輸入3到9位的數字"
            }
        },
        shipments: {
            title: "配送資訊",
            about_bundle_capacity: "每【{{amount}}個】商品",
            about_fee: "關於配送費",
            about_fee_detail: "▼關於配送費的詳細資訊",
            period: "▼預計配送時間"
        },
        order_info: {
            play_ticket: "免費票券：",
            order_date: "訂單日期：",
            play_amount: {
                single: "{{amount}}次抽獎",
                multi: "{{amount}}連抽"
            },
            payment_method: {
                label: "支付方式：",
                no_info: "無支付資訊"
            },
            delivery: {
                title: {
                    delivery: "配送狀態：",
                    local_pickup: "領取狀態："
                },
                status: {
                    not_shipped: "未發貨",
                    shipped: "已發貨",
                    not_picked: "未領取",
                    picked: "已領取",
                    no_delivery: "該訂單設定為不配送"
                }
            }
        }
    },
    pages: {
        gacha: {
            prizes: {
                about: "關於商品",
                lineup: "商品列表",
                view_collection: "查看獲得的商品"
            },
            purchase_benefits: "購買特典",
            collection_items: "获奖商品",
            collection: "收藏",
            "ticket/coupon": "票券・優惠券",
            guide_to_collection: "獲獎的數位內容・票券・優惠券可在\"获奖商品\"中找到",
            delivery: {
                price: "配送費",
                detail: "關於配送費"
            },
            play: {
                single: "{{amount}}次抽獎",
                multi: "{{amount}}連抽",
                single_lottery: "進行{{amount}}次抽獎",
                multi_lottery: "進行{{amount}}連抽",
                button: "購買",
                view_play_buttons: "購買此轉蛋",
                has_play_ticket: "可以使用免費票券"
            },
            unplayable: {
                comingsoon: "準備中",
                discontinued: "銷售結束",
                soldout: "已售罄",
                closing: "停止銷售"
            },
            result: {
                title: "抽獎結果"
            }
        },
        onepass: {
            invalid_format: "請輸入正確格式",
            please_enter: "請輸入代碼",
            please_login: "請登入",
            send_error: "發送失敗"
        },
        local_pickup: {
            qr_code_title: "取貨 QR 碼",
            qr_code_description: "請將此 QR 碼出示給現場工作人員以領取商品",
            display_qr_code: "顯示取貨 QR 碼",
            pickup_code: "代碼：",
            user_reference_number: "您的參考號碼：",
            calling_reference_number: "呼叫中的參考號碼：",
            pickup_location: "取貨地點：",
            pickup_location_detail: "取貨地點詳細資訊",
            enter_prize_pickup: "進入領獎",
            local_pickup_description: "此轉蛋僅限會場領取"
        },
        check_in: {
            title: "簽到",
            modal: {
                title: "此轉蛋僅限參加者",
                description: "抵達會場後，請點擊'簽到'以確認您的到達",
                check_in_progress_1: "您是否在會場附近，",
                check_in_progress_2: "檢查中..."
            },
            result: {
                success: "簽到成功",
                not_nearby: {
                    title: "簽到失敗",
                    description: "請在會場附近再試一次"
                },
                permission_denied: {
                    title: "未獲得位置信息許可",
                    ios_description: "請前往瀏覽器設置->網站設置->位置信息並選擇允許，然後再試一次",
                    android_description: "啟動設置應用，前往應用與通知->高級->應用權限->位置信息，為Chrome開啟位置信息後重新加載頁面並再試一次"
                },
                get_location_failed: {
                    title: "獲取位置信息失敗",
                    description: "請再試一次"
                }
            }
        },
        prize_ticket: {
            no_available_ticket: "沒有可用的票券/優惠券",
            used_ticket: "已使用的票券/優惠券"
        },
        my_page: {
            title: "帳戶",
            nickname: {
                edit: "編輯暱稱",
                register: "註冊暱稱"
            },
            user_id: "使用者ID",
            shipping_info: {
                title: "配送資訊",
                register: "註冊配送資訊",
                edit: "編輯配送資訊"
            },
            delete_account: {
                title: "刪除帳戶",
                modal: {
                    title: "您確定要刪除您的帳戶嗎？",
                    description: "刪除帳戶後，所有註冊的個人資訊和購買歷史將被刪除，您將無法訪問或下載任何已購買的數位內容。未發貨的商品將按正常流程發貨。",
                    agree: "同意",
                    confirm: "刪除帳戶",
                    cancel: "取消",
                    success: {
                        title: "帳戶刪除成功",
                        description: "感謝您的使用"
                    },
                    error: {
                        title: "帳戶刪除失敗",
                        description: "請重新登入並再試一次"
                    }
                }
            }
        },
        buy: {
            title: "輸入送貨資訊",
            submit_title: "購買",
            buy_again: "再次購買",
            return_to_top: "返回頂部",
            cancel: "取消",
            check_warning: {
                title: "注意事項",
                form_title: "我已確認注意事項"
            },
            shippings: {
                title: "配送資訊",
                different_address_warning: "更改配送資訊可能會產生配送費",
                cannot_ship_warning: "所選的轉蛋無法配送到您帳戶中註冊的地址。請輸入一個可配送的地址。",
                forms: {
                    country: "配送國家",
                    name: "姓名"
                },
                no: {
                    title: "不配送獲獎商品",
                    description: "您只能觀看數位內容。",
                    warning: "獲獎商品將不會發送。請注意。",
                    confirm_title: "您確定不需要配送獲獎商品嗎？",
                    confirm_description: "您只能觀看數位內容。如果您不想收到獲獎商品的配送，請使用此選項。"
                }
            },
            payments: {
                title: "支付方式",
                methods: {
                    credit: "信用卡",
                    paypay: "PayPay",
                    carrier: "運營商支付",
                    unionpay: "銀聯"
                },
                credit: {
                    title: "信用卡資訊",
                    cardno: "卡號",
                    exp: "有效期限",
                    holder_name: "持卡人姓名",
                    security_code: "安全碼",
                    what_is_security_code: "什麼是安全碼",
                    quantity_full: "新增信用卡時，請先刪除已註冊的信用卡",
                    register_card: "註冊信用卡資訊",
                    supported_card_text: "支持以下信用卡"
                },
                carrier: {
                    title: "選擇運營商支付"
                },
                purchase_detail_description: {
                    credit: "※信用卡明細將顯示為\"SWAMP STORE\"。\n\"SWAMP STORE\"是此服務的購買明細。",
                    app: "※App明細將顯示為\"SWAMP STORE\"。\n\"SWAMP STORE\"是此服務的購買明細。"
                }
            },
            tipping_message: {
                title: "向賣家發送消息",
                placeholder: "輸入你的消息",
                invalid_length: "消息太長了",
                caution: "此消息可能會在創作者的直播中使用，請不要輸入任何不當內容。"
            }
        },
        history: {
            title: "購買歷史",
            no_history: "沒有購買歷史",
            guide_to_collection: "您贏得的數字內容可以從獲得的商品中查看",
            items_not_yet_received: "尚未收到的商品",
            order_detail: {
                title: "訂單詳情"
            }
        }
    },
    country: {
        JP: "日本",
        US: "美國",
        CN: "中國",
        KR: "韓國",
        TW: "台灣",
        HK: "香港"
    },
    errors: {
        "404": {
            title: "指定的URL頁面不存在",
            description: "URL可能輸入錯誤，或該頁面已被刪除。如果問題仍然存在，請透過帳戶 > 聯絡我們與我們聯繫。"
        },
        "500": {
            title: "發生錯誤",
            description: "URL可能輸入錯誤，或該頁面已被刪除。如果問題仍然存在，請透過帳戶 > 聯絡我們與我們聯繫。"
        },
        not_found: {
            title: "找不到頁面",
            description: "URL可能輸入錯誤，或該頁面已被刪除。如果問題仍然存在，請透過帳戶 > 聯絡我們與我們聯繫。"
        },
        failed: {
            check_in: "簽到失敗",
            get_gacha_detail: "獲取活動資訊失敗",
            get_gacha_history: "獲取購買歷史失敗"
        }
    }
};
